import styled from "styled-components";

const Link = styled.div`
  display: inline-block;
  cursor: pointer;
`;

export default Link;



// WEBPACK FOOTER //
// ./src/components/Auth/StyledComponents/FakeLink.js